import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { compassOutline, homeOutline } from 'ionicons/icons';
import { ComponentAccess } from '../../../../common/decorators/component-access.decorator';
import { CommonRoute } from '../../../../common/enums/common-route.enum';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: true,
  imports: [
    IonContent,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    IonButton,
    IonIcon,
    RouterLink,
  ],
})
@ComponentAccess('NotFoundComponent')
export class NotFoundComponent {
  readonly CommonRoute = CommonRoute;

  constructor() {
    addIcons({ compassOutline, homeOutline });
  }
}
